import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Button,
  Paper,
  Typography,
  Container,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import Toolbar from "./Toolbar";
import {
  apiEndpoints,
  apiPutRequest,
  apiGetRequest,
  apiDeleteRequest,
} from "src/utils/api/api";
import { addCreatedAndUpdatedFields } from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const RowButtons = (row, customHandlers, ...rest) => {
  return (
    <Box>
      <Tooltip title="Edytuj">
        <IconButton
          aria-label="edytuj"
          component={RouterLink}
          to={`/kalendarz/edycjawydarzenia/${row.id}`}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const EventsView = ({
  enableGlobalLoader,
  disableGlobalLoader,
  setLogoutUser,
}) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [dialogOpen, setOpen] = useState(false);
  const [dialogPublishOpen, setPublisOpen] = useState(false);
  const [publishedNews, setPublishedNews] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getCalendarEvents.path, true)
      .then((data) => {
        disableGlobalLoader();
        setRows(
          addCreatedAndUpdatedFields(
            data,
            "createdBy",
            "createdAt",
            "updatedBy",
            "updatedAt",
            ", "
          )
        );
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const publishHandler = (row) => {
    setPublishedNews(row);
    handleClickPublishOpen(row);
  };

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      fieldName: "name",
      sortable: true,
      main: true,
      label: "Nazwa",
    },
    {
      id: "startsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "startsAt",
      sortable: true,
      main: false,
      label: "Data rozpoczęcia",
    },
    {
      id: "endsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "endsAt",
      sortable: true,
      main: false,
      label: "Data zakończenia",
    },
    {
      id: "created",
      fieldName: "createdAt",
      fieldName2: "createdBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto utworzył",
    },
    {
      id: "updated",
      fieldName: "updatedAt",
      fieldName2: "updatedBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto zmodyfikował",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      customHandlers: { publishHandler },
      component: RowButtons,
    },
  ];

  const onSelectedRowIdsChanged = (viewSelectedRowIds) => {
    setSelectedRowIds(viewSelectedRowIds);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    enableGlobalLoader();
    setOpen(false);

    apiDeleteRequest(
      apiEndpoints.deleteCalendarEvent.path,
      selectedRowIds,
      true
    )
      .then((data) => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
      })
      .catch((error) => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
      });
  };

  const handleClickPublishOpen = () => {
    setPublisOpen(true);
  };

  const handlePublishDialogClose = () => {
    setPublisOpen(false);
  };

  const handlePublish = () => {
    enableGlobalLoader();
    setPublisOpen(false);

    if (publishedNews) {
      apiPutRequest(
        apiEndpoints.setNewsPublishedStatus.path,
        {
          id: publishedNews.id,
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          setReloadCounter(reloadCounter + 1);
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    }
  };

  return (
    <Page className={classes.root} title="Aktualności - wersje robocze">
      <Container maxWidth={false}>
        <Toolbar dialogHandler={handleClickOpen} />
        <KmFilteredTable
          headCells={headCells}
          rows={rows}
          onSelectedRowIdsChange={onSelectedRowIdsChanged}
        />
        <Dialog
          fullScreen={fullScreen}
          open={dialogOpen}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {"Usuwanie artykułów"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Czy na na pewno chcesz usunąć zaznaczone elementy?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose} color="primary">
              Nie
            </Button>
            <Button onClick={handleDelete} color="primary" autoFocus>
              Tak
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
});

export default connect(null, mapDispatchToProps)(EventsView);
